// extracted by mini-css-extract-plugin
export default {"gameLoader":"dummy-ui_gameLoader__e49sw","darkUI":"dummy-ui_darkUI__qBOSU"};